import {
  Sidebar as SidebarRoot,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  useSidebar,
} from "@altimateai/lego";
import { SidebarHeader as Header } from "./components/SidebarHeader";
import { SidebarFooter as Footer } from "./components/SidebarFooter";
import { SidebarNav } from "./components/SidebarNav";

const Sidebar = () => {
  const { state } = useSidebar();

  return (
    <SidebarRoot className={"al-bg-white al-z-[44]"} collapsible="icon">
      <SidebarHeader>
        <Header />
      </SidebarHeader>
      <SidebarContent className={state === "expanded" ? "al-px-2" : "al-px-1"}>
        <SidebarNav />
      </SidebarContent>
      <SidebarFooter>
        <Footer />
      </SidebarFooter>
    </SidebarRoot>
  );
};

export { Sidebar };
